import { Injectable, Optional } from '@angular/core';
import { AuthorizationConfig } from '../privilege-authorization.modal';
import { TranslateService } from '@ngx-translate/core';
import { UIMenuEntity } from 'src/app/shared/models/Application/UIMenuEntity';
import * as appApiResources from '../../shared/globalcontants';

@Injectable({
    providedIn: 'root'
})

  export class PrevilegeAuthorizationService {
    previlgeConfig: AuthorizationConfig;
    AccessDeneid: any;
    public _authorizationInfo: any;
    MenuKeys: Array<any> = [];
    constructor(@Optional() config: AuthorizationConfig, private translateService: TranslateService) {
        if (config) { this.previlgeConfig = config; }
        this.AccessDeneid = [{
             Inventory: ['GetInventoryList'],
             Retail: ['GetInventoryList'],
             Requisition: ['GetRequisitionSummary_All', 'PostTransferStd'],
             Transfers: ['GetRequisitionSummary', 'GetTransfersSummary', 'PostTransferStd'],
             TransfersOut : ['GetRequisitionSummary', 'GetTransfersSummary', 'PostTransferStd'],
             'Purchase Order' : ['GetPOSummary', 'GetRequisitionSummary', 'PostPurchaseorder'],
             'Spoilage & Loss' : ['GetSpoilageSummary' , 'PostSpoilageStd'],
             'Physical Inventory' : ['BuildList'],
             // Messages: ['PostMessages','SaveMessages','DeleteMessages'],
             'Pending Approvals': ['PostProcessOrders', 'GetOrders'],
             Receiving: ['GetSavedInvoice', 'SaveMa', 'PostMa']

        }];
      }
      /**
       * @version UI 13.2
       * @method previlegAuthorization
       * @param PrevilgeKey array of any
       * @returns boolean
       */

      previlegAuthorization(PrevilgeKey: Array<string>, SubModuleKey = null, isForSearch = false): boolean {
        try {
          let isAuthenticatedPrevilege = false;
          const privilegeModule = this.getauthModuleKey(isForSearch);
        if (privilegeModule && privilegeModule.length > 0 ) {
          if(SubModuleKey === null){
            const GetModule = privilegeModule[0].SubModules
          .filter((modules: any) =>  modules.PermissionResource
          .findIndex((f: any) =>  PrevilgeKey.some(s => s === f.Name) && f.IsActive) > -1 );
          if (GetModule && GetModule.length > 0 ) {
              isAuthenticatedPrevilege = true;
            }
          } else {
            const SubModuleName: any = privilegeModule[0].SubModules.filter(x => {if(x.Name === SubModuleKey){return x.PermissionResource}});
            const GetModule = SubModuleName[0].PermissionResource.filter((f: any) =>  PrevilgeKey.find(s => (s === f.Name) && f.IsActive));
          if (GetModule && GetModule.length > 0 ) {
              isAuthenticatedPrevilege = true;
            }
            // console.log(isAuthenticatedPrevilege);
          }
        } else {
          console.log('Assign Invalid key check previlegeModule');
        }
        return isAuthenticatedPrevilege;
        } catch (error) {
          console.log('error occured MismatchModule', error);
        }
      }
      previlegAuthenticated(PrevilgeKey: string): boolean {
        try {
          let isAuthenticatedPrevilege = false;
          const getKey = this.getPrevilegeModuleKey();
        if (getKey && getKey !== null && getKey !== undefined) {
          const indexValue = this.previlgeConfig.previlege[ getKey ] ?
          this.previlgeConfig.previlege[ getKey ].findIndex(x => x === PrevilgeKey) : -1;
          if (indexValue > -1) {
              isAuthenticatedPrevilege = true;
            }
        } else {
          console.log('Assign Invalid key check previlegeModule');
        }
        return isAuthenticatedPrevilege;
        } catch (error) {
          console.log('error occured MismatchModule', error);
        }
      }
      previlegAuthenticatedIsRetail(PrevilgeKey: string, getKey: string): boolean {
        try {
          let isAuthenticatedPrevilege = false;
        if (getKey && getKey !== null && getKey !== undefined) {
          const indexValue = this.previlgeConfig.previlege[ getKey ] ?
          this.previlgeConfig.previlege[ getKey ].findIndex(x => x === PrevilgeKey) : -1;
          if (indexValue > -1) {
              isAuthenticatedPrevilege = true;
            }
        } else {
          console.log('Assign Invalid key check previlegeModule');
        }
        return isAuthenticatedPrevilege;
        } catch (error) {
          console.log('error occured MismatchModule', error);
        }
      }
      PrevilegeModuleAuthentication(PrevilgeKey: string) {
        try {
          let isAuthenticatedPrevilege = false;
          if (PrevilgeKey && PrevilgeKey !== null && PrevilgeKey !== undefined) {
            const indexValue = this.previlgeConfig.previlege[ PrevilgeKey ];
            if (indexValue && indexValue.length > 0) {
              isAuthenticatedPrevilege = true;
            }
          } else {
            console.log('Assign Invalid key check previlegeModule');
          }
          return isAuthenticatedPrevilege;
        } catch (error) {
          console.log('PrevilegeModuleAuthentication');
        }
      }
      privilegeKpiauth(TransactionsStatus: any) {
        try {
          let isAuthenticatedPrevilege: Boolean = false;
          const getKey = this.getprivilegeKpiauthKey(TransactionsStatus);
          if (getKey && getKey !== null && getKey !== undefined) {
            const previlegeModule = this.previlgeConfig.previlege[ getKey ] ? this.previlgeConfig.previlege[ getKey ].length : null;
            if (previlegeModule && previlegeModule > 0) {
                isAuthenticatedPrevilege = true;
              }
          } else {
            console.log('Assign Invalid key check previlegeModule');
          }
          return isAuthenticatedPrevilege;
        } catch (error) {
          console.log('error occured privilegeKpiauth', error);
        }
      }
      getAuthorizationMenu(decodeObject: any) {
        if (decodeObject) {
          this.MenuKeys = Object.keys(decodeObject);
        }
      }
      getprivilegeKpiauthKey(TransactionsStatuskey: string): string {
        let previlegeKpiKey: string;
        switch (TransactionsStatuskey) {
          case 'Requisition' : {
            previlegeKpiKey = 'Requisition';
             break;
          }
          case 'Transfers': {
            previlegeKpiKey = 'Transfers';
             break;
          }
          case 'PO\'s': {
            previlegeKpiKey = 'Purchase Order';
             break;
          }
          case 'Spoilage': {
            previlegeKpiKey = 'Spoilage & Loss';
             break;
          }
          case 'RQA': {
            previlegeKpiKey = 'Retail';
             break;
          }
          default: {
            previlegeKpiKey = null;
             break;
          }
       }
       return previlegeKpiKey;
      }
      /**
       * @version UI 13.2
       * @method getauthModuleKey
       * @returns ModuleKey
       */

      getauthModuleKey(isForSearch = false): Array<any> {
         try {
         const privilageModule = this.previlgeConfig.previlege.filter(keys => keys.Name === (isForSearch ? appApiResources.previlgeModule.MasterManagement : this.previlgeConfig.previlegeModule));
         return privilageModule;
         } catch ( error ) {
           console.log('error occured key not defined', error);
         }
      }

      getPrevilegeModuleKey() {
        let selectedPrevilege: string;
         try {
         const previlegeKeys =  Object.keys(this.previlgeConfig.previlege);
         const assignKeys = previlegeKeys.filter(keys => keys === this.previlgeConfig.previlegeModule);
         selectedPrevilege = assignKeys[0];
         return selectedPrevilege;
         } catch ( error ) {
           console.log('error occured key not defined', error);
         }
      }
      getPrevilegeReverseTransfer(dataInput: any) {
        const MoreOptionData = [];
        dataInput.filter(x => {
            if (x.privilegeKey === undefined) {
              MoreOptionData.push(x);
            } else {
              if (this.previlegAuthorization([x.privilegeKey])) {
                MoreOptionData.push(x);
              }
            }
        });
        return MoreOptionData;
      }

      previlegeAuthenticcatedModule(authenticatedKeys: Array<any>) {
        let authenticatedModule = false;
        const getKey = this.getPrevilegeModuleKey();
        authenticatedKeys.forEach(permissionKeys => {
          const selectedIndex = this.previlgeConfig.previlege[ getKey ].findIndex(x => x === permissionKeys);
          if (selectedIndex > -1) {
            authenticatedModule = true;
          }
        });
        return authenticatedModule;
      }

      getPrevilageLandingkey(Modulename: string) {
        let previlegekeyCollection: Array<string> = [];
        switch (Modulename) {
          case this.translateService.instant('uiMenus.Inventory'):
            previlegekeyCollection = ['Inventory', 'Retail'];
          break;
          case this.translateService.instant('uiMenus.Requisition'):
            previlegekeyCollection = ['Requisition'];
          break;
          case this.translateService.instant('uiMenus.Transfers'):
            previlegekeyCollection = ['Transfers', 'TransfersOut'];
          break;
          case this.translateService.instant('uiMenus.In-transit Delivery'):
            previlegekeyCollection = ['In-transit Delivery'];
          break;
          case this.translateService.instant('uiMenus.Transfer Acknowledgement'):
            previlegekeyCollection = ['Transfers'];
          break;
          case this.translateService.instant('uiMenus.Physical Inventory'):
            previlegekeyCollection = ['Physical Inventory'];
          break;
          case this.translateService.instant('uiMenus.Purchase Order'):
            previlegekeyCollection = ['Purchase Order', 'Change Orders'];
          break;
          case this.translateService.instant('uiMenus.Receiving'):
            previlegekeyCollection = ['Receiving'];
          break;
          case this.translateService.instant('uiMenus.Document Approvals'):
            previlegekeyCollection = ['Pending Approvals'];
          break;
          case this.translateService.instant('uiMenus.Spoilage & Loss'):
            previlegekeyCollection = ['Spoilage & Loss'];
          break;
          case this.translateService.instant('uiMenus.Offline'):
            previlegekeyCollection = ['No Previlege Needed'];
          break;
          case this.translateService.instant('uiMenus.Settings'):
            previlegekeyCollection = ['No Previlege Needed'];
          break;
          case this.translateService.instant('uiMenus.About'):
            previlegekeyCollection = ['No Previlege Needed'];
          break;
          case this.translateService.instant('uiMenus.Logout'):
            previlegekeyCollection = ['No Previlege Needed'];
          break;
          case this.translateService.instant('message.messages'):
            previlegekeyCollection = ['Messages'];
          break;
          case this.translateService.instant('uiMenus.Manage Mobile License'):
            previlegekeyCollection = ['Manage Mobile License'];
          break;
        }
        return previlegekeyCollection;

      }

      getPrevilegeauthCollection(PrevilegeModule: Array<any>) {
        const autharizationPrevilege = [];
        PrevilegeModule.forEach(previlegeModule => {
           const previlageModule = this.previlgeConfig.previlege[ previlegeModule ];
           if (previlageModule) {
            autharizationPrevilege.push(previlageModule);
           }
        });
        return autharizationPrevilege;
      }

      findLandingAuthorization(authorizationModule: Array<any>) {
        let issAccessed = false;
        let isAccessedCount = 0;
        authorizationModule.forEach(dinedKey => {
          if (dinedKey !== 'No Previlege Needed') {
            const previlageModule = this.previlgeConfig.previlege[ dinedKey ];
            const AccessModule    = this.AccessDeneid[0][dinedKey];
            if (previlageModule && AccessModule) {
               AccessModule.forEach(x => {
               const keyIndex =  previlageModule.findIndex(moduleIndex => moduleIndex === x);
               if (keyIndex === -1) {
                issAccessed = false;
               } else {
                isAccessedCount = isAccessedCount + 1;
               }
               });
            }
          } else {
            isAccessedCount = 1;
          }
        });
        const result =  isAccessedCount > 0 ? true : false;
        return result;
      }
      /**
       * @version 13.2 Modernization
       * @method navigationAuthorization
       * @input UI menu
       * @description UI menu access
       * @param authorizationModule
       * @returns
       */
      navigationAuthorization(NavigationData: Array<UIMenuEntity>): Array<UIMenuEntity> {
         const authorizationData = JSON.parse(window.localStorage.getItem('AuthorizationData'));
         if( authorizationData && authorizationData.length > 0 ){
              NavigationData.forEach((navMenu: UIMenuEntity)=>{
                  const getAuthorizationkey: Array<any> = (navMenu.hasOwnProperty('AuthorizationKey')) ? navMenu.AuthorizationKey : [];
                  if ( getAuthorizationkey && getAuthorizationkey.length > 0 ){
                    getAuthorizationkey.forEach((authKey: string)=> {
                      authorizationData.forEach((authData: any) => {
                          if( authKey === authData.Name){
                            const AuthSubModulekey: Array<any> = (navMenu.hasOwnProperty('SubModuleKey')) ? navMenu.SubModuleKey : [];
                            if( AuthSubModulekey && AuthSubModulekey.length > 0){
                              AuthSubModulekey.forEach((subModuleKey: string)=>{
                               const subModuleList: Array<any> = authData.SubModules.filter((f: any)=> f.Name === subModuleKey);
                               if( subModuleList && subModuleList.length > 0 ){
                                    if( subModuleList && subModuleList[0].hasOwnProperty('PermissionResource')) {
                                      if ( subModuleList[0].PermissionResource.length > 0 ){
                                          const permissionSet: Array<any> = subModuleList[0].PermissionResource.filter((p: any)=>  navMenu.PermissionResourcekey.findIndex(f=> f === p.Name ) > -1 );
                                          if( permissionSet && permissionSet.length > 0 ){
                                            // permissionSet.forEach((x: any)=> {
                                            //     navMenu.Visible = x.IsActive;
                                            //     navMenu.Enabled = x.IsActive;
                                            // });
                                            if(navMenu.SubModuleKey.length>1){
                                              const res = permissionSet.some(x => x.IsActive);
                                              if(!navMenu.Visible && !navMenu.Enabled){
                                                navMenu.Visible = res;
                                                navMenu.Enabled = res;
                                              }
                                            }
                                            else{
                                              const res = permissionSet.some(x => x.IsActive);
                                              navMenu.Visible = res;
                                              navMenu.Enabled = res;
                                            }                                            
                                          }
                                      }
                                    }
                               }
                              });
                            }
                          }
                      });
                    });
                  }
              })
         }
        return NavigationData;
      }

  }
